module.exports = __webpack_public_path__ + "static/media/image_processing_ca_2.1afd1a44.png";